import kamala from '../../kamala'
import Chat from './Chat'

Chat.install = function (Vue) {
  kamala(Vue)
  Vue.component(Chat.name, Chat)
}

export default Chat
